<template>
    <div id="new">
        <div class="contents">
            <div class="ui active inverted dimmer" v-if="is_processing || !is_initialized">
                <div class="ui text loader">
                    {{ $t('ui.general.initializing') }}
                </div>
            </div>
            <div class="ui form" v-else>
                <h2 class="ui header">
                    {{ $t('ui.page_titles.new_asset') }}
                </h2>
                <div class="eight wide field" :class="{'error': if_error('category')}">
                    <label>
                        {{ $t('models.attributes.assets.category') }}
                    </label>
                    <div class="ui right labeled action input">
                        <input type="text" v-model="asset.category" :placeholder="$t('ui.pages.assets.helps.write_or_use_category_list')">
                        <div class="ui dropdown label" v-dropdown>
                            <div class="text">
                                {{ $t('ui.pages.assets.have_category') }}
                            </div>
                            <i class="dropdown icon"></i>
                            <div class="menu">
                                <div v-for="category in $store.state.provider.assets_module.categories" class="item" @click="set_category(category)">{{category}}</div>
                            </div>
                        </div>
                        <div type="submit" class="ui icon button" @click="clear_category" :data-tooltip="$t('ui.pages.assets.clear_value')" v-popup><i class="ui remove icon"></i></div>
                    </div>
                    <div v-if="if_error('category')" class="ui pointing red basic label">
                        {{ error_message("category") }}
                    </div>
                </div>
                <div class="eight wide field" :class="{'error': if_error('number')}">
                    <label>
                        {{ $t('models.attributes.assets.number') }}
                    </label>
                    <input type="text" v-model="asset.number" :placeholder="$t('models.attributes.assets.number')">
                    <div v-if="if_error('number')" class="ui pointing red basic label">
                        {{ error_message("number") }}
                    </div>
                </div>
                <div class="eight wide field" :class="{'error': if_error('note')}">
                    <label>
                        {{ $t('models.attributes.assets.note') }}
                    </label>
                    <textarea v-model="asset.note" rows="8" cols="80"></textarea>
                    <div v-if="if_error('note')" class="ui pointing red basic label">
                        {{ error_message("note") }}
                    </div>
                </div>
                <div class="ui basic positive button" @click="create">
                    {{ $t('ui.general.submit') }}
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import ErrorBox from './errors.vue'
export default {
    name: "NewAsset",
    prop: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            asset: {
                number: null,
                category: null,
                note: null
            },
            errors: [],
            error_columns: []
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "new_asset") {
                this.init()
            }
        },
    },
    computed: {
        layout() {
            return this.$parent
        }
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.asset = {
                    number: null,
                    category: null,
                    note: null,
                }
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        create() {
            this.is_processing = true
            this.errors = []
            this.error_columns = []
            axios.post(
                    this.$store.state.provider.routes.api_v1_provider_assets_create,
                    this.asset,
                    {headers: { Authorization: localStorage.getItem("authentication_token") }}
                )
                .then(response => {
                    if (response.data.status == "success") {
                        if (this.$store.state.provider.assets_module.categories.indexOf(response.data.asset.category) == -1) {
                            this.$store.state.provider.assets_module.categories.push(response.data.asset.category)
                        }
                        this.$store.state.provider.assets_module.current_category = response.data.asset.category
                        this.$router.push("/provider/assets/index/" + response.data.asset.category)
                    } else {
                        this.errors = response.data.errors
                        this.error_columns = Object.keys(response.data.errors)
                    }
                })
                .catch(error => {
                    this.errors.push(
                        this.$t('ui.notifications.error.create__name', {
                            name: this.$t('models.assets'),
                            reason: ': ' + error
                        })
                    )
                })
            this.is_processing = false
        },
        set_category(category) {
            this.asset.category = category
        },
        clear_category() {
            this.asset.category = null
        },
        if_error(column_name) {
            if (this.error_columns.indexOf(column_name) != -1) {
                return true
            } else {
                return false
            }
        },
        error_message(column_name) {
            return _.join(this.errors[column_name], ', ')
        }
    },
    components: {
        ErrorBox
    }
}
</script>

<style scoped>
</style>
